import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CertificatesPendingService, CustomValidators, FeedMessageService, showSuccess } from '@services/index.service';
import { DialogConfirmCancelComponent } from '@shared/index.shared';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { filter, finalize, tap } from 'rxjs/operators';
import { ErrorCode, PreloadedCertificateActivateRequest, Response } from '@models/index.model';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-dialog-pending-cert-activate',
    templateUrl: './dialog-pending-cert-activate.component.html',
    styles: [],
    standalone: false
})
export class DialogPendingCertActivateComponent implements OnInit {
  public isMobile: boolean;
  public activateCertificateForm: UntypedFormGroup;

  public hidePassword: boolean = true;
  public hidePin: boolean = true;
  public hidePinRepeat: boolean = true;

  public sendingInfo: boolean = false;

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private _dialogRef: MatDialogRef<DialogPendingCertActivateComponent>,
    private _fb: UntypedFormBuilder,
    private _dialog: MatDialog,
    private _preloadedCertificates: CertificatesPendingService,
    private _notify: FeedMessageService
  ) {
    this.isMobile = environment.platform === 'mobile';
    this.activateCertificateForm = this._initCertificatePinForm(this.data.id);
  }

  public ngOnInit() {
  }

  private _initCertificatePinForm(preloadedCertificateId: number): UntypedFormGroup {
    return this._fb.group(
      {
        preloadedCertificateId: [preloadedCertificateId, [Validators.required]],
        password: [null, [Validators.required]],
        pin: [null, [Validators.minLength(4), Validators.maxLength(8)]],
        pinRepeat: [null, [Validators.minLength(4), Validators.maxLength(8)]],
      },
      {
        validators: [CustomValidators.fieldsMatch(['pin', 'pinRepeat'])],
      }
    );
  }

  public isFieldInvalid(fieldControl: AbstractControl): boolean {
    return (fieldControl.dirty || fieldControl.touched) && !fieldControl.value;
  }

  public onActivate(): void {
    const activatePreloadedCertificateRequest: PreloadedCertificateActivateRequest = {
      preloadedCertificateId: this.activateCertificateForm.get('preloadedCertificateId').value,
      password: this.activateCertificateForm.get('password').value,
      pin: this.activateCertificateForm.get('pin').value
    };


    this.sendingInfo = true;
    this._preloadedCertificates.activatePreloadedCertificate(activatePreloadedCertificateRequest)
    .pipe(
      tap((res: Response<Array<number>>) => {
        if (res.errorCode === ErrorCode.OK) {
          this._notify.feedBackResult(res.messageType, res.message, showSuccess)
          this._dialogRef.close(true);
        }
      }),
      finalize(() => {
        this._resetCertActivationForm();
        this.sendingInfo = false;
      })
    ).subscribe();
  }

  private _resetCertActivationForm(): void {
    Object.keys(this.activateCertificateForm.controls)
      .filter((keyName: string) => keyName !== 'preloadedCertificateId')
      .forEach((keyName: string) => {
        const control = this.activateCertificateForm.get(keyName);
        control.reset();
        control.updateValueAndValidity();
      });
  }

  public onCancel(): void {
    const dialogRef = this._dialog.open(DialogConfirmCancelComponent, {
      width: '400px',
      data: {},
      disableClose: true,
    });
    dialogRef
      .afterClosed()
      .pipe(filter((res: boolean) => res))
      .subscribe(_ => {
        this._dialogRef.close(false);
      });
  }
}
